import { ItemVerbaDropDown } from "../../models/item_verba_dropdown";
import { IGetItensVerbaDropDownUseCase } from "../../../presentation/useCases/read/get_itens_verba_dropdown_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetItensVerbaDropDownUseCase
 */

export class GetItensVerbaDropDownUseCase implements IGetItensVerbaDropDownUseCase {
  private cachedData?: ItemVerbaDropDown[];

  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async getItensVerbaDropDown(): Promise<ItemVerbaDropDown[]> {
    const response = await this.repository.getItensVerbaDropDown();
    return response;
  }
}